package com.wintermar.inspection.core.ui.component.snackbar

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.wintermar.inspection.core.ui.component.LinkText
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.component.button.IconButton
import com.wintermar.inspection.core.ui.component.snackbar.util.SnackBarPosition
import com.wintermar.inspection.core.ui.component.snackbar.util.SnackBarState
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.dismiss_snackbar
import inspection.composeapp.generated.resources.ic_alert
import inspection.composeapp.generated.resources.ic_close
import inspection.composeapp.generated.resources.icon_content_description
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun SnackBar(
    snackBarHostState: SnackbarHostState,
    state: SnackBarState? = null
) {
    val variant = state?.variant?.palette()
    val dimension = LocalAppTheme.current.dimension

    Box(
        modifier = Modifier.fillMaxSize()
    ) {
        SnackbarHost(
            hostState = snackBarHostState,
            modifier = Modifier
                .align(
                    if (state?.position == SnackBarPosition.BOTTOM) Alignment.BottomCenter
                    else Alignment.TopCenter
                )
                .fillMaxWidth(state?.maxWidth ?: 1f)
                .padding(
                    vertical = if (state?.position == SnackBarPosition.BOTTOM) dimension.spacing.space5
                    else dimension.spacing.space9,
                    horizontal = dimension.spacing.space5
                )
        ) {
            Row(
                modifier = Modifier
                    .background(
                        color = variant?.backgroundColor ?: LocalContentColor.current,
                        shape = RoundedCornerShape(dimension.radius.md)
                    )
                    .border(
                        width = 1.dp,
                        color = variant?.borderColor ?: LocalContentColor.current,
                        shape = RoundedCornerShape(dimension.radius.md)
                    )
                    .padding(
                        vertical = dimension.spacing.space2,
                        horizontal = dimension.spacing.space3
                    ),
                horizontalArrangement = Arrangement.spacedBy(
                    space = dimension.spacing.space3,
                    alignment = Alignment.CenterHorizontally
                )
            ) {
                Icon(
                    painter = painterResource(variant?.icon ?: Res.drawable.ic_alert),
                    tint = variant?.iconColor ?: LocalContentColor.current,
                    modifier = Modifier.size(dimension.size.icon.s),
                    contentDescription = stringResource(Res.string.icon_content_description)
                )
                TextBodySmall(
                    text = state?.message ?: "",
                    color = { it.subtle },
                    modifier = Modifier
                        .weight(1f)
                        .padding(top = dimension.spacing.space1 / 1.5f)
                )

                Row(
                    horizontalArrangement = Arrangement.spacedBy(
                        dimension.spacing.space2
                    ),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    if (state?.actionValue != null) {
                        LinkText(
                            text = state.actionValue,
                            bold = false,
                            underline = true,
                            onClick = {
                                snackBarHostState.currentSnackbarData?.dismiss()
                                state.onAction()
                            }
                        )
                    }
                    IconButton(
                        icon = Res.drawable.ic_close,
                        backgroundColor = Color.Transparent,
                        tint = LocalAppTheme.current.color.icon.subtle,
                        contentDescription = stringResource(Res.string.dismiss_snackbar),
                        onClick = {
                            snackBarHostState.currentSnackbarData?.dismiss()
                        }
                    )
                }
            }
        }
    }
}
